import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import { get_summary_report, init_simulation } from '../services/api';
import { rootRoute } from "../../../config";
import { errorMsg } from "../../../helper/helpers";
import info from '../assets/info.png';
import General_feedback_active from "../assets/General_feedback_active.png";
import General_feedback_deactive from "../assets/General_feedback_deactive.png";
import Financial_analysis_active from "../assets/Finacial_analysis_active.png";
import Financial_analysis_deactive from "../assets/Financial_analysis_deactive.png";
import order_analysis_active from "../assets/order_analysis_active.png";
import order_analysis_deactive from "../assets/order_analysis_deactive.png";
import Button from '../../common/Button'
import leftArrow from "../assets/leftArrow.png";
import rightArrow from "../assets/rightArrow.png";
import prevArrow from "../assets/prevArrow.png";
import QmModuleStyle from '../styles/qm.module.css';
import CostAnalysisGraph from "./CostAnalysisGraph";
import RevenueGraph from "./RevenueGraph";
import InventoryGraph from "./InventoryGraph";

const Summary = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);

  const [summaryReports, setSummaryReports] = useState({});
  const [simulationDetailSummary, setSimulationDetailSummary] = useState([]);
  const [attempt, setAttempt] = useState(queryParams.get("attempt"));
  const [pagination, setPagination] = useState({ "prev": false, "next": false });
  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location, setError] = useOutletContext();
  const [isActive, setIsActive] = useState("generalFeedback");
  const [executioninstanceid, setExecutioninstanceid] = useState("");
  const [page, setPage] = useState(1);
  const [pageHeight, setPageHeight] = useState("");
  const summaryBtnStyle = { color: "white", borderRadius: "40px", margin: "0px", padding: "16px 55px", fontSize: "16px" };
  const noOfRatings = [1, 2, 3, 4, 5];
  const starRating = Number(summaryReports?.FinancialAnalysis?.starRating);
  const TargetSR = Number(summaryReports?.FinancialAnalysis?.targetStarRating);

  let session_id = queryParams.get("sid");
  let resource_id = queryParams.get("resid");
  let course_id = queryParams.get("cid");
  let user_id = queryParams.get("userid");
  let attempt_id = queryParams.get("attempt");
  let role = queryParams.get("role");

  const formatNum = (number) => {
    let formattedNumber = number?.toString();
    formattedNumber = formattedNumber?.includes('.') ? formattedNumber?.replace(/\.?0*$/, '') : formattedNumber;
    return formattedNumber;
  }
  const checkNum = (num) => {
    return (!isNaN(num)) ? num < 0
      ? `-$${Math?.abs(num)?.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`
      : `$${num?.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}` : "";
  };
  const handleSetActive = (e) => {
    const generalFeedbackOffset =
      document.getElementById(`${QmModuleStyle.generalFeedback}`).offsetTop - 20;
    const financialAnalysisOffset =
      document.getElementById(`${QmModuleStyle.financialAnalysis}`).offsetTop - 25;
    const qualityAnalysisOffset =
      document.getElementById(`${QmModuleStyle.qualityAnalysis}`).offsetTop - 25;

      if (e.type === "click") {
        if (e.currentTarget.classList.contains("generalFeedbackParent")) {
          document.getElementById(`${QmModuleStyle.generalFeedback}`).querySelector("h2").tabIndex = -1;
          document.getElementById(`${QmModuleStyle.generalFeedback}`).querySelector("h2").focus();
          if (document.querySelector(`.${QmModuleStyle['summary-content-box']}`) != null) {
            document.querySelector(`.${QmModuleStyle['summary-content-box']}`).scrollTop =
              generalFeedbackOffset - 20;
          }
        } else if (e.currentTarget.classList.contains("qualityAnalysisParent")) {
          document.getElementById(`${QmModuleStyle.qualityAnalysis}`).querySelector("h2").tabIndex = -1;
          document.getElementById(`${QmModuleStyle.qualityAnalysis}`).querySelector("h2").focus();
          if (document.querySelector(`.${QmModuleStyle['summary-content-box']}`) != null) {
            document.querySelector(`.${QmModuleStyle['summary-content-box']}`).scrollTop =
              qualityAnalysisOffset - 0;
          }
  
        } else if (
          e.currentTarget.classList.contains("financialAnalysisParent")
        ) {
          document.getElementById(`${QmModuleStyle.financialAnalysis}`).querySelector("h2").tabIndex = -1;
          document.getElementById(`${QmModuleStyle.financialAnalysis}`).querySelector("h2").focus();
          if (document.querySelector(`.${QmModuleStyle['summary-content-box']}`) != null) {
            document.querySelector(`.${QmModuleStyle['summary-content-box']}`).scrollTop =
              financialAnalysisOffset - 0;
          }
        }
      }
    const scrollPosition = e.currentTarget.scrollTop;

    if (
      scrollPosition >= generalFeedbackOffset &&
      scrollPosition < financialAnalysisOffset
    ) {
      document.querySelector(`.generalFeedbackParent `).blur();
      setIsActive("generalFeedback");
    } else if (
      scrollPosition >= financialAnalysisOffset &&
      scrollPosition < qualityAnalysisOffset
    ) {
      document.querySelector(`.financialAnalysisParent `).blur();
      setIsActive("financialAnalysis");
    } else if (scrollPosition >= qualityAnalysisOffset) 
    {
      document.querySelector(`.qualityAnalysisParent `).blur();
      setIsActive("qualityAnalysis");
    }
  };
  const navigateToSimulation = () => {
    navigate(rootRoute + "/qm/simulation");
  };
  const handlePopupExitSim = (e) => {
    window.close();
  }
  const initSummary = () => {
     (simObj?.status != 'COMPLETED' && (attempt == undefined && user_id == undefined)) && navigate(`${rootRoute}/qm/simulation`);
    window.$("html, body").animate({ scrollTop: 0, }, 100);
    window.$(`.${QmModuleStyle['summary-content-box']}`).animate({ scrollTop: 0, }, 100);
  };
  const backToSimulationList = () => {
    setIsLoader(true);
    if (role == "student") {
      navigate(rootRoute + `/qm/studentreview?${queryParams}`);
    } else {
      navigate(rootRoute + `/qm/instructorreview?${queryParams}`);
    }
  }
  const getNextAttempt = () => {
    setIsLoader(true);
      let index = simulationDetailSummary?.findIndex((sdObj) => sdObj.attemptno == attempt);
      let currSdSObj = simulationDetailSummary[index + 1];
      if (currSdSObj != undefined) {
        setAttempt(currSdSObj.attemptno);
        queryParams.set("attempt", currSdSObj.attemptno);
        setExecutioninstanceid(currSdSObj?.executioninstanceid);
        (simulationDetailSummary[index + 2] != undefined) ? setPagination({ "prev": true, "next": false }) : setPagination({ "prev": false, "next": true });
      } else {
        setPagination({ "prev": false, "next": true });
        setIsLoader(false);
      }
  }
  const getPrevAttempt = () => {
    setIsLoader(true);
      let index = simulationDetailSummary?.findIndex((sdObj) => sdObj.attemptno == attempt);
      let currSdSObj = simulationDetailSummary[index - 1];
      if (currSdSObj != undefined) {
        setAttempt(currSdSObj.attemptno);
        queryParams.set("attempt", currSdSObj.attemptno);
        setExecutioninstanceid(currSdSObj?.executioninstanceid);
        (simulationDetailSummary[index - 2] != undefined) ? setPagination({ "prev": false, "next": false }) : setPagination({ "prev": true, "next": false });
      } else {
        setPagination({ "prev": true, "next": false });
        setIsLoader(false);
      }
  }
  const OnLoadPagination = () => {
    let lastObjIndex = simulationDetailSummary?.length - 1;
    let firstObjIndex = 0;
    let currentIndex = simulationDetailSummary?.findIndex((sdObj) => sdObj.attemptno == attempt);
    (currentIndex == lastObjIndex) && setPagination({ "prev": false, "next": true });
    (currentIndex == firstObjIndex) && setPagination({ "prev": true, "next": false });
    if ((currentIndex != lastObjIndex) && (currentIndex != firstObjIndex)) {
      setPagination({ "prev": false, "next": false });
    }
  }
  const getSimulationDetailSummary = () => {
    setSimulationDetailSummary((attempt != undefined && user_id != undefined) ? simObj?.simulationdetails : []);
    setIsLoader(false);
  };
  const updateExcutionInstanceId = () => {
    if (attempt != undefined && user_id != undefined) {
      setExecutioninstanceid(simulationDetailSummary?.filter((sdObj) => sdObj.attemptno == attempt)[0]?.executioninstanceid)
    } else {
      setExecutioninstanceid(simObj?.executioninstanceid)
    }
  }
  const getSummaryReport = () => {
    ((simObj?.sessionid != undefined || session_id != undefined) && executioninstanceid != undefined && executioninstanceid.length > 0) && get_summary_report((simObj?.sessionid || session_id), executioninstanceid).then(
      (response) => {
        if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
          setError(response?.data)
      }
      else{
        setSummaryReports(response?.data);
        //console.log(response.data)
        OnLoadPagination();
        setIsLoader(false);
      }
      }).catch((error) => {
        // setError(errorMsg);
        setError({"id":"00000","msg":errorMsg})
        console.log(error);
      });
  };
  const generalClickHandler = (e) => {
    if (window.innerWidth > 570) {
      e.preventDefault();
      document.querySelector(".generalFeedbackParent").click();
      e.stopPropagation();
    }
    return 0;
  }
  const financialClickHandler = (e) => {
    if (window.innerWidth > 570) {
      e.preventDefault();
      document.querySelector(".financialAnalysisParent").click();
      e.stopPropagation();
    }
    return 0;
  }
  const qualityClickHandler = (e) => {
    if (window.innerWidth > 570) {
      e.preventDefault();
      document.querySelector(".qualityAnalysisParent").click();
      e.stopPropagation();
    }
    return 0;
  }
  useEffect(() => {
    setIsLoader(true);
    if (session_id != "" && simObj?.laststate == undefined) {//&& queryParams.get("sid") == undefined
      //setError(null);
      init_simulation(session_id).then(function (response) {
        if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
          setError(response?.data)
      }
      else{
        // console.log(response.data);
        setSimObj(Object.assign(response?.data,{"simulationdetails":simObj?.simulationdetails}));
        setError(null);
      }
      }).catch((error) => {
        // setError(errorMsg);
        setError({"id":"00000","msg":errorMsg})
      })
    }
    setIsOverlay(false);
  }, [])
  useEffect(() => { updateExcutionInstanceId(); }, [simulationDetailSummary])
  useEffect(() => { getSimulationDetailSummary(); }, [attempt])
  useEffect(() => { getSummaryReport(); }, [executioninstanceid])
  useEffect(() => {
    if(document.querySelector("header.header") != null){
      document.querySelector("header.header").style.display = "none";
    }
    if(document.querySelector(".App .row") != null){
      document.querySelector(".App .row").style.minHeight = "auto";
    }
    
    setIsLoader(true);
    initSummary();
    setAttempt(queryParams.get("attempt"))
    const heading = document.querySelector(
      `.${CSS.escape(QmModuleStyle["summary-container"])} header.header h1`
    );
  
    if (heading) {
      heading.tabIndex = -1;
      heading.focus();
    }
    // document.querySelector(`.${QmModuleStyle['summary-container']} header.header h1`).tabIndex = -1;
    // document.querySelector(`.${QmModuleStyle['summary-container']} header.header h1`).focus();
    // const summaryPageHeight = window.innerHeight - document.querySelector(`.${QmModuleStyle['summary-container']} header.header`).clientHeight - document.getElementsByClassName(`${QmModuleStyle['summary-footer']}`)[0].clientHeight - document.querySelector(`.footer`).clientHeight;
    // setPageHeight(summaryPageHeight - 1);
    const header = document.querySelector(
      `.${CSS.escape(QmModuleStyle['summary-container'])} header.header`
      );
      const summaryFooter = document.getElementsByClassName(
        QmModuleStyle['summary-footer']
      )[0];
      const footer = document.querySelector('.footer');
  
      if (header && summaryFooter && footer) {
        const summaryPageHeight =
          window.innerHeight -
          header.clientHeight -
          summaryFooter.clientHeight -
          footer.clientHeight;
  
        setPageHeight(summaryPageHeight - 1);
      }
    document.title = "Quality Management | Summary";

    if (attempt != undefined && user_id != undefined) {
      // if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
      //   document.querySelector("footer.footer .footer-nav .footer-links").style.display = "none";
      // }
      // if (document.querySelector("footer.footer .container") != null) {
      //   document.querySelector("footer.footer .container").style.justifyContent = "center";
      // }
      if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
        document.querySelector("footer.footer .footer-nav .footer-links").firstChild.style.display = "none";
      }
    }

    return () => {
      if(document.querySelector("header.header") != null){
        document.querySelector("header.header").style.display = "block";
      }
      if(document.querySelector(".App .row") != null){
        document.querySelector(".App .row").style.minHeight = "100vh";
      }
      if (attempt != undefined && user_id != undefined) {
        if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
          document.querySelector("footer.footer .footer-nav .footer-links").style.display = "block";
        }
        if (document.querySelector("footer.footer .container") != null) {
          document.querySelector("footer.footer .container").style.justifyContent = "space-between";
        }
      }

    };
  }, [simObj?.sessionid || session_id]);

  return (
    <motion.div className={`${QmModuleStyle['summary-container']}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} >
      <header className={`header ${QmModuleStyle.header}`}>
        <div className={`container ${QmModuleStyle.container}`}>
          <div className={`${QmModuleStyle['icon-header-box']}`}>
            {
              (attempt != undefined && user_id != undefined) && <button onClick={backToSimulationList}><img src={prevArrow} /></button>
            }
            <h1 className={`ui header title ${QmModuleStyle.ui} ${QmModuleStyle.header} ${QmModuleStyle.title}`}>
              {attempt != undefined ? `Summary Report(Attempt ${attempt})` : "The year is over! Review your results below."}
            </h1>
          </div>
          {
            (attempt != undefined && user_id != undefined && simulationDetailSummary?.length != 1) && <div className={`${QmModuleStyle['pagination-icons']}`}>
              <button disabled={pagination.prev} onClick={getPrevAttempt}><img src={leftArrow} /></button>
              <button disabled={pagination.next} onClick={getNextAttempt}><img src={rightArrow} /></button>
            </div>
          }
        </div>
      </header>
      <div className={`ui stackable two column grid ${QmModuleStyle.ui} ${QmModuleStyle.stackable} ${QmModuleStyle.column} ${QmModuleStyle.grid} ${QmModuleStyle['summary-content']} `}>
        <div className={`column ${QmModuleStyle.column} ${QmModuleStyle['navigation-tab']}`}>
          <ul className={`ui link list ${QmModuleStyle.ui} ${QmModuleStyle.link} ${QmModuleStyle.list}`}>
            <li className={`item generalFeedbackParent ${QmModuleStyle['item']} ${isActive === "generalFeedback" ? `${QmModuleStyle['active']}` : ""}`}
              onClick={(e) => {
                handleSetActive(e);
                setIsActive("generalFeedback");
                // e.target.focus();
                e.stopPropagation();
              }}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  e.target.click();
                }
              }}
              // tabIndex={`${isActive === "generalFeedback" ? -1 : 0}`}
              tabIndex={0}>
              <a href={`#${QmModuleStyle.generalFeedback}`} onClick={generalClickHandler} tabIndex={-1}>
                <img src={isActive === "generalFeedback" ? General_feedback_active : General_feedback_deactive} alt="" />
                <span>GENERAL FEEDBACK</span>
              </a>
            </li>
            <li className={`item financialAnalysisParent ${QmModuleStyle['item']} ${isActive === "financialAnalysis" ? `${QmModuleStyle['active']}` : ""}`}
              onClick={(e) => {
                handleSetActive(e);
                setIsActive("financialAnalysis");
                // e.target.focus();
                e.stopPropagation();
              }}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  e.target.click();
                }
              }}
              // tabIndex={`${isActive === "financialAnalysis" ? -1 : 0}`}
              tabIndex={0}>
              <a href={`#${QmModuleStyle.financialAnalysis}`} onClick={financialClickHandler} tabIndex={-1}>
                <img src={isActive === "financialAnalysis" ? Financial_analysis_active : Financial_analysis_deactive} alt="" />
                <span>FINANCIAL ANALYSIS</span>
              </a>
            </li>
            <li className={`item qualityAnalysisParent ${QmModuleStyle['item']} ${isActive === "qualityAnalysis" ? `${QmModuleStyle['active']}` : ""}`}
              onClick={(e) => {
                handleSetActive(e);
                setIsActive("qualityAnalysis");
                // e.target.focus();
              }}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  e.target.click();
                }
              }}
              // tabIndex={`${isActive === "qualityAnalysis" ? -1 : 0}`}
              tabIndex={0}>
              <a href={`#${QmModuleStyle.qualityAnalysis}`} onClick={qualityClickHandler} tabIndex={-1}>
                <img src={isActive === "qualityAnalysis" ? order_analysis_active : order_analysis_deactive} alt="" />
                <span>QUALITY ANALYSIS</span>
              </a>
            </li>
          </ul>
        </div>
        <div className={`column ${QmModuleStyle.column} ${QmModuleStyle['summary-content-box']} `} onWheel={handleSetActive} style={{ height: pageHeight + "px" }} >
          <div className={`${QmModuleStyle.section}`} id={`${QmModuleStyle.generalFeedback}`} style={{ "marginTop": "0px" }}>
            <h2>General Feedback</h2>
            <table className={`ui unstackable table ${QmModuleStyle.ui} ${QmModuleStyle.unstackable} ${QmModuleStyle.table}`}>
              <thead>
                <tr>
                  <th id="prfMetric" scope="col" className={`eight wide ${QmModuleStyle.eight} ${QmModuleStyle.wide}`}>Performance Metric</th>
                  {summaryReports?.GeneralFeedback?.last_availableCash !== "NA" ? (
                  <th id="prevSim" scope="col" className={`four wide right aligned ${QmModuleStyle.four} ${QmModuleStyle.wide} ${QmModuleStyle.right} ${QmModuleStyle.aligned}`}>
                    Previous Simulation
                  </th>
                  ) : (null)}
                  <th id="currSim" scope="col" className={`four wide right aligned ${QmModuleStyle.four} ${QmModuleStyle.wide} ${QmModuleStyle.right} ${QmModuleStyle.aligned}`}>
                    Current Simulation
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th id="avlCashPrft" colSpan={summaryReports?.GeneralFeedback != undefined && summaryReports?.GeneralFeedback?.last_availableCash !== "NA" ? 3 : 2} scope="row" className={`${QmModuleStyle['row-heading']}`}>
                    Available Cash and Profit
                  </th>
                </tr>
                <tr className={`${QmModuleStyle['indent-row']}`}>
                  <th id="avlCash" headers="avlCashPrft" className={`eight wide ${QmModuleStyle.eight} ${QmModuleStyle.wide}`}>Available Cash</th>
                  {summaryReports?.GeneralFeedback?.last_availableCash != "NA" ? (
                    <td headers="avlCashPrft avlCash prevSim" className={`four wide right aligned ${QmModuleStyle.four} ${QmModuleStyle.wide} ${QmModuleStyle.right} ${QmModuleStyle.aligned}`}>
                    {checkNum(Number(summaryReports?.GeneralFeedback?.last_availableCash))}
                  </td>
                  ) : (null)}
                  <td headers="avlCashPrft avlCash currSim" className={`four wide right aligned ${QmModuleStyle.four} ${QmModuleStyle.wide} ${QmModuleStyle.right} ${QmModuleStyle.aligned}`}>
                    {checkNum(Number(summaryReports?.GeneralFeedback?.availableCash))}
                  </td>
                </tr>
                <tr className={`${QmModuleStyle['indent-row']}`}>
                  <th id="prfAchvd" headers="avlCashPrft" className={`eight wide ${QmModuleStyle.eight} ${QmModuleStyle.wide}`}>Profit Achieved</th>
                 {summaryReports?.GeneralFeedback?.last_totalProfit != "NA" ? ( 
                  <td headers="avlCashPrft prfAchvd prevSim" className={`four wide right aligned ${QmModuleStyle.four} ${QmModuleStyle.wide} ${QmModuleStyle.right} ${QmModuleStyle.aligned}`}>
                    {checkNum(Number(summaryReports?.GeneralFeedback?.last_totalProfit))}
                  </td>
                  ) : (null)}
                  <td headers="avlCashPrft prfAchvd currSim" className={`four wide right aligned ${QmModuleStyle.four} ${QmModuleStyle.wide} ${QmModuleStyle.right} ${QmModuleStyle.aligned}`}>
                    {checkNum(Number(summaryReports?.GeneralFeedback?.totalProfit))}
                  </td>
                </tr>
                <tr className={`${QmModuleStyle['indent-row']}`}>
                  <th id="prftPer" headers="avlCashPrft" className={`eight wide ${QmModuleStyle.eight} ${QmModuleStyle.wide}`}>Profit (In %)</th>
                 {summaryReports?.GeneralFeedback?.last_totalProfit != "NA" ? (
                  <td headers="avlCashPrft prftPer prevSim" className={`four wide right aligned ${QmModuleStyle.four} ${QmModuleStyle.wide} ${QmModuleStyle.right} ${QmModuleStyle.aligned}`}>
                    {summaryReports?.GeneralFeedback?.last_ProfitPercentage}%
                  </td>
                  ) : (null)}
                  <td headers="avlCashPrft prftPer currSim" className={`four wide right aligned ${QmModuleStyle.four} ${QmModuleStyle.wide} ${QmModuleStyle.right} ${QmModuleStyle.aligned}`}>
                    {summaryReports?.GeneralFeedback?.ProfitPercentage}%
                  </td>
                </tr>
                <tr>
                  <td headers="avlCashPrft" role="cell" className={`${QmModuleStyle['text-td']}`} colSpan={summaryReports?.GeneralFeedback?.last_availableCash !== "NA" ? 3 : 2} >
                    {summaryReports?.GeneralFeedback?.ProfitGoal}
                  </td>
                </tr>
                <tr>
                  <th id="failrRate" colSpan={summaryReports?.GeneralFeedback != undefined && summaryReports?.GeneralFeedback?.last_availableCash !== "NA" ? 3 : 2} scope="row" className={`${QmModuleStyle['row-heading']}`}>
                    Failure Rate and Cost of Quality
                  </th>
                </tr>
                <tr className={`${QmModuleStyle['indent-row']}`}>
                  <th id="costOfExtFailr" headers="failrRate" className={`eight wide ${QmModuleStyle.eight} ${QmModuleStyle.wide}`}>Cost Of External Failure (In $)</th>
                  {summaryReports?.GeneralFeedback?.last_totalCostOfExternalFailures != "NA" ? (
                    <td headers="failrRate costOfExtFailr prevSim" className={`four wide right aligned ${QmModuleStyle.four} ${QmModuleStyle.wide} ${QmModuleStyle.right} ${QmModuleStyle.aligned}`}>
                    {checkNum(Number(summaryReports?.GeneralFeedback?.last_totalCostOfExternalFailures))}
                  </td>
                  ) : (null)}
                  <td headers="failrRate costOfExtFailr currSim" className={`four wide right aligned ${QmModuleStyle.four} ${QmModuleStyle.wide} ${QmModuleStyle.right} ${QmModuleStyle.aligned}`}>
                    {checkNum(Number(summaryReports?.GeneralFeedback?.totalCostOfExternalFailures))}
                  </td>
                </tr>
                <tr className={`${QmModuleStyle['indent-row']}`}>
                  <th id="costOfIntFailr" headers="failrRate" className={`eight wide ${QmModuleStyle.eight} ${QmModuleStyle.wide}`}>Cost Of Internal Failure (In $)</th>
                  {summaryReports?.GeneralFeedback?.last_totalCostofInternalFailure != "NA" ? (
                  <td headers="failrRate costOfIntFailr prevSim" className={`four wide right aligned ${QmModuleStyle.four} ${QmModuleStyle.wide} ${QmModuleStyle.right} ${QmModuleStyle.aligned}`}>
                    {checkNum(Number(summaryReports?.GeneralFeedback?.last_totalCostofInternalFailure))}
                  </td>
                  ) : (null)}
                  <td headers="failrRate costOfIntFailr currSim" className={`four wide right aligned ${QmModuleStyle.four} ${QmModuleStyle.wide} ${QmModuleStyle.right} ${QmModuleStyle.aligned}`}>
                    {checkNum(Number(summaryReports?.GeneralFeedback?.totalCostofInternalFailure))}
                  </td>
                </tr>
                <tr className={`${QmModuleStyle['indent-row']}`}>
                  <th id="copInvstmnt" headers="failrRate" className={`eight wide ${QmModuleStyle.eight} ${QmModuleStyle.wide}`}>Cost Of Preventive Investments (In $)</th>
                  {summaryReports?.GeneralFeedback?.last_totalCostOfPreventiveInvestment != "NA" ? (
                  <td headers="failrRate copInvstmnt prevSim" className={`four wide right aligned ${QmModuleStyle.four} ${QmModuleStyle.wide} ${QmModuleStyle.right} ${QmModuleStyle.aligned}`}>
                    {checkNum(Number(summaryReports?.GeneralFeedback?.last_totalCostOfPreventiveInvestment))}
                  </td>
                  ) : (null)}
                  <td headers="failrRate copInvstmnt currSim" className={`four wide right aligned ${QmModuleStyle.four} ${QmModuleStyle.wide} ${QmModuleStyle.right} ${QmModuleStyle.aligned}`}>
                    {checkNum(Number(summaryReports?.GeneralFeedback?.totalCostOfPreventiveInvestment))}
                  </td>
                </tr>
                <tr className={`${QmModuleStyle['indent-row']}`}>
                  <th id="coaInvstmnt" headers="failrRate" className={`eight wide ${QmModuleStyle.eight} ${QmModuleStyle.wide}`}>Cost of Appraisal Investments (In $)</th>
                  {summaryReports?.GeneralFeedback?.last_totalCostOfAssesmentInvestment != "NA" ? (
                  <td headers="failrRate coaInvstmnt prevSim" className={`four wide right aligned ${QmModuleStyle.four} ${QmModuleStyle.wide} ${QmModuleStyle.right} ${QmModuleStyle.aligned}`}>
                    {checkNum(Number(summaryReports?.GeneralFeedback?.last_totalCostOfAssesmentInvestment))}
                  </td>
                  ) : (null)}
                  <td headers="failrRate coaInvstmnt currSim" className={`four wide right aligned ${QmModuleStyle.four} ${QmModuleStyle.wide} ${QmModuleStyle.right} ${QmModuleStyle.aligned}`}>
                    {checkNum(Number(summaryReports?.GeneralFeedback?.totalCostOfAssesmentInvestment))}
                  </td>
                </tr>
                <tr className={`${QmModuleStyle['indent-row']}`}>
                  <th id="totCOQ"  headers="failrRate" className={`eight wide ${QmModuleStyle.eight} ${QmModuleStyle.wide}`}>Total Cost Of Quality (In $)</th>
                  {summaryReports?.GeneralFeedback?.last_totalCostOfQuality != "NA" ? (
                  <td headers="failrRate totCOQ prevSim" className={`four wide right aligned ${QmModuleStyle.four} ${QmModuleStyle.wide} ${QmModuleStyle.right} ${QmModuleStyle.aligned}`}>
                    {checkNum(Number(summaryReports?.GeneralFeedback?.last_totalCostOfQuality))}
                  </td>
                  ) : (null)}
                  <td headers="failrRate totCOQ currSim" className={`four wide right aligned ${QmModuleStyle.four} ${QmModuleStyle.wide} ${QmModuleStyle.right} ${QmModuleStyle.aligned}`}>
                    {checkNum(Number(summaryReports?.GeneralFeedback?.totalCostOfQuality))}
                  </td>
                </tr>
                <tr className={`${QmModuleStyle['indent-row']}`}>
                  <th id="avgFailrRate"  headers="failrRate" className={`eight wide ${QmModuleStyle.eight} ${QmModuleStyle.wide}`}>Average Failure Rate (In %)</th>
                  {summaryReports?.GeneralFeedback?.last_averageFailureRate != "NA" ? (
                  <td headers="failrRate avgFailrRate prevSim" className={`four wide right aligned ${QmModuleStyle.four} ${QmModuleStyle.wide} ${QmModuleStyle.right} ${QmModuleStyle.aligned}`}>
                    {summaryReports?.GeneralFeedback?.last_averageFailureRate}%
                  </td>
                  ) : (null)}
                  <td headers="failrRate avgFailrRate prevSim" className={`four wide right aligned ${QmModuleStyle.four} ${QmModuleStyle.wide} ${QmModuleStyle.right} ${QmModuleStyle.aligned}`}>
                    {summaryReports?.GeneralFeedback?.averageFailureRate}%
                  </td>
                </tr>
                <tr>
                  <td role="cell"  headers="failrRate" className={`${QmModuleStyle['text-td']}`} colSpan={summaryReports?.GeneralFeedback?.last_availableCash !== "NA" ? 3 : 2}>
                    {summaryReports?.GeneralFeedback?.averageFailureRateVerdict}
                  </td>
                </tr>
                <tr>
                  <th id="strRating" colSpan={summaryReports?.GeneralFeedback != undefined && summaryReports?.GeneralFeedback?.last_availableCash !== "NA" ? 3 : 2} scope="row" className={`${QmModuleStyle['row-heading']}`}>
                    Star Rating
                  </th>
                </tr>
                <tr className={`${QmModuleStyle['indent-row']}`}>
                  <th id="strRate" headers="strRating" className={`eight wide ${QmModuleStyle.eight} ${QmModuleStyle.wide}`}>Star Rating</th>
                  {summaryReports?.GeneralFeedback?.last_starRating != "NA" ? (
                  <td headers="strRating strRate prevSim" className={`four wide right aligned ${QmModuleStyle.four} ${QmModuleStyle.wide} ${QmModuleStyle.right} ${QmModuleStyle.aligned}`}>
                    {formatNum(summaryReports?.GeneralFeedback?.last_starRating)}
                  </td>
                  ) : (null)}
                  <td headers="strRating strRate currSim" className={`four wide right aligned ${QmModuleStyle.four} ${QmModuleStyle.wide} ${QmModuleStyle.right} ${QmModuleStyle.aligned}`}>
                   {formatNum(summaryReports?.GeneralFeedback?.starRating)}
                  </td>
                </tr>
                <tr>
                  <td headers="strRating" role="cell" className={`${QmModuleStyle['text-td']}`} colSpan={summaryReports?.GeneralFeedback?.last_availableCash !== "NA" ? 3 : 2}>
                    {summaryReports?.GeneralFeedback?.starRatingVerdict}
                  </td>
                </tr>
                <tr>
                  <th id="msgNotfcn" colSpan={summaryReports?.GeneralFeedback != undefined && summaryReports?.GeneralFeedback?.last_availableCash !== "NA" ? 3 : 2} scope="row" className={`${QmModuleStyle['row-heading']}`}>
                    Messages and Notifications
                  </th>
                </tr>
                <tr>
                  <td headers="msgNotfcn" role="cell" className={`${QmModuleStyle['text-td']}`} colSpan={summaryReports?.GeneralFeedback?.last_availableCash !== "NA" ? 3 : 2}>
                      {summaryReports?.GeneralFeedback?.ReadArtifact}
                      {summaryReports?.GeneralFeedback?.RemaingArtifactVedict}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className={`${QmModuleStyle.section} ${QmModuleStyle['financial-analysis-div']}`} id={`${QmModuleStyle.financialAnalysis}`}>
            <h2 className={`ui header ${QmModuleStyle.ui} ${QmModuleStyle.header}`}>Financial Analysis</h2>
            <p>{summaryReports?.FinancialAnalysis?.ProfitGoal}</p>
            <div className={`ui stackable two column grid ${QmModuleStyle.ui} ${QmModuleStyle.stackable} ${QmModuleStyle.column} ${QmModuleStyle.grid} ${QmModuleStyle['qm-financial']}`}>
              <div className={`column ${QmModuleStyle.column} ${QmModuleStyle['table-block']}`}>
                <table className={`ui unstackable table ${QmModuleStyle.ui} ${QmModuleStyle.unstackable} ${QmModuleStyle.table}`}>
                  <tbody>
                    <tr>
                      <td>Cost of external failure</td>
                      <td>{checkNum(Number(summaryReports?.FinancialAnalysis?.totalCostOfExternalFailures))}</td>
                    </tr>
                    <tr>
                      <td>Cost of internal failure</td>
                      <td>{checkNum(Number(summaryReports?.FinancialAnalysis?.totalCostofInternalFailure))}</td>
                    </tr>
                    <tr>
                      <td>Cost of appraisal investments	</td>
                      <td>{checkNum(Number(summaryReports?.FinancialAnalysis?.totalCostOfAssesmentInvestment))}</td>
                    </tr>
                    <tr>
                      <td>Cost of preventive investments</td>
                      <td>{checkNum(Number(summaryReports?.FinancialAnalysis?.totalCostOfPreventiveInvestment))}</td>
                    </tr>
                    <tr>
                      <td>Cost of other investments</td>
                      <td>{checkNum(Number(summaryReports?.FinancialAnalysis?.totalCostOfRedHerringInvestment))}</td>
                    </tr>
                    <tr>
                      <td><strong>Total cost of quality</strong></td>
                      <td><strong>{checkNum(Number(summaryReports?.FinancialAnalysis?.totalCostOfQuality))}</strong></td>
                    </tr>
                    <tr>
                      <td colSpan={2}>
                        <hr aria-hidden="true" role="presentation"></hr>
                      </td>
                    </tr>
                    <tr>
                      <td><strong>Profit</strong></td>
                      <td><strong>{checkNum(Number(summaryReports?.FinancialAnalysis?.totalProfit))}</strong></td>
                    </tr>
                    <tr>
                      <td colSpan={2}>
                        <hr aria-hidden="true" role="presentation"></hr>
                      </td>
                    </tr>
                    <tr>
                      <td><strong>Available Cash</strong></td>
                      <td><strong>{checkNum(Number(summaryReports?.FinancialAnalysis?.availableCash))}</strong></td>
                    </tr>
                    <tr>
                      <td colSpan={2}>
                        <hr aria-hidden="true" role="presentation"></hr>
                      </td>
                    </tr>
                    <tr>
                      <td><strong>Star Rating</strong></td>
                      <td>
                        <span className="sr-only">{summaryReports?.FinancialAnalysis?.starRating} star rating</span>
                        <ul className={`${QmModuleStyle["rating-list"]}`}>
                          {noOfRatings.map((number, index) =>
                            number <= starRating ? (
                              <li key={number}>
                                <span className={`fa fa-star checked ${QmModuleStyle["fa"]} ${QmModuleStyle["fa-star"]}`} />
                              </li>
                            ) : Number(starRating) === starRating &&
                              starRating % 1 !== 0 &&
                              number <= Math.round(starRating) ? (
                              <li key={number}>
                                <span className={`fa fa-star-half-o ${QmModuleStyle["fa"]} ${QmModuleStyle["fa-star-half-o"]}`} />
                              </li>
                            ) : (
                              <li key={number}>
                                <span className={`fa fa-star-o ${QmModuleStyle["fa"]} ${QmModuleStyle["fa-star-o"]}`} />
                              </li>
                            )
                          )}
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td><strong>Your Goal</strong></td>
                      <td>
                        <span className="sr-only">{summaryReports?.FinancialAnalysis?.targetStarRating} star rating</span>
                        <ul className={`${QmModuleStyle["rating-list"]}`}>
                          {noOfRatings.map((number, index) =>
                            number <= TargetSR ? (
                              <li key={number}>
                                <span className={`fa fa-star checked ${QmModuleStyle["fa"]} ${QmModuleStyle["fa-star"]}`} />
                              </li>
                            ) : Number(TargetSR) === TargetSR &&
                              TargetSR % 1 !== 0 &&
                              number <= Math.round(TargetSR) ? (
                              <li key={number}>
                                <span className={`fa fa-star-half-o ${QmModuleStyle["fa"]} ${QmModuleStyle["fa-star-half-o"]}`} />
                              </li>
                            ) : (
                              <li key={number}>
                                <span className={`fa fa-star-o ${QmModuleStyle["fa"]} ${QmModuleStyle["fa-star-o"]}`} />
                              </li>
                            )
                          )}
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2}>
                        <hr aria-hidden="true" role="presentation"></hr>
                      </td>
                    </tr>
                    <tr>
                      <td><strong>Profit Percentage</strong></td>
                      <td><strong>{summaryReports?.FinancialAnalysis?.percentageProfit}%</strong></td>
                    </tr>
                    <tr>
                      <td><strong>Average Failure Rate</strong></td>
                      <td><strong>{summaryReports?.FinancialAnalysis?.averageFailureRate}%</strong></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className={`column ${QmModuleStyle.column} ${QmModuleStyle['graph-block']}`}>
                <div className={`${QmModuleStyle['cost-analysis-graph']}`}>
                  <CostAnalysisGraph summaryReports={summaryReports}></CostAnalysisGraph>
                  <div className={`${QmModuleStyle['CostAnalysis-legends']}`}>
                  <div className={`${QmModuleStyle['CA-Appraisal']}`}><span className={`${QmModuleStyle['CAgraphpattern']}`} aria-hidden="true" role="presentation"><div className={`${QmModuleStyle['Appraisal-legend-sign1']}`}></div></span>Cost of Appraisal  Investments</div>
                  <div className={`${QmModuleStyle['CA-External']}`}><span className={`${QmModuleStyle['CAgraphpattern']}`} aria-hidden="true" role="presentation"><div className={`${QmModuleStyle['External-legend-sign2']}`}></div></span>Cost of External  Failures</div>
                  <div className={`${QmModuleStyle['CA-Internal']}`}><span className={`${QmModuleStyle['CAgraphpattern']}`} aria-hidden="true" role="presentation"><div className={`${QmModuleStyle['Internal-legend-sign3']}`}></div></span>Cost of Internal  Failures</div>
                  <div className={`${QmModuleStyle['CA-Preventive']}`}><span className={`${QmModuleStyle['CAgraphpattern']}`} aria-hidden="true" role="presentation"><div className={`${QmModuleStyle['Preventive-legend-sign4']}`}></div></span>Cost of Preventive  Investments</div>
                  <div className={`${QmModuleStyle['CA-Other']}`}><span className={`${QmModuleStyle['CAgraphpattern']}`} aria-hidden="true" role="presentation"><div className={`${QmModuleStyle['Other-legend-sign5']}`}></div></span>Cost of Other  Investments</div>
                </div>
                </div>
                <div className={`${QmModuleStyle['qm-revenue-graph']}`}>
                  <div className={`${QmModuleStyle['costquality-legends']}`}>
                    <div className={`${QmModuleStyle['container-div']}`} aria-hidden="true">
                      <div className={`${QmModuleStyle['circle-line']}`}></div>
                      <div className={`${QmModuleStyle['horizontal-line-circle']}`}></div>
                    </div>
                    <div>Revenue</div>
                    <div className={`${QmModuleStyle['container-div']}`} aria-hidden="true">
                      <div className={`${QmModuleStyle['horizontal-line-rhombus']}`}></div>
                      <div className={`${QmModuleStyle['rhombus']}`}></div>
                      <div className={`${QmModuleStyle['circle-rhombus']}`}></div>
                    </div>
                    <div>Cost of Quality</div>
                  </div>
                  <RevenueGraph type={"yearly"} simObj={simObj} isResult={true} summaryGraphData={summaryReports?.graphdata} setSimObj={setSimObj} attempt={attempt}></RevenueGraph>
                </div>
              </div>
            </div>
          </div>
          <div className={`${QmModuleStyle.section} ${QmModuleStyle['quality-analysis-div']}`} id={`${QmModuleStyle.qualityAnalysis}`}>
            <h2 className={`ui header ${QmModuleStyle.ui} ${QmModuleStyle.header}`}>Quality Analysis</h2>
            <div className={`${QmModuleStyle['quality-analysis-content']}`}>
              <div className={`${QmModuleStyle['inventorygraph-legend']}`}><span className={`${QmModuleStyle['inventory-legend']} ${QmModuleStyle['inventorypattern']}`} aria-hidden="true">&#9632;</span>Failure Rate</div>
              <InventoryGraph type={"yearly"} simObj={simObj} isResult={true} summaryGraphData={summaryReports?.graphdata} setSimObj={setSimObj} attempt={attempt}></InventoryGraph>
            </div>
            <div className={`ui grid ${QmModuleStyle.ui} ${QmModuleStyle.grid} ${QmModuleStyle['quality-analysis-content']} ${QmModuleStyle.bordered}`}>
              <div className={`column ${QmModuleStyle.column} ${QmModuleStyle['content-block']}`}>
                <h3>Internal Failure Rate</h3>
                <p>{summaryReports?.QualityAnalysis?.averageInternalFailureRateVerdict}</p>
              </div>
              <div className={`column ${QmModuleStyle.column} ${QmModuleStyle['failure-rate-block']}`}>
                <div className={`${QmModuleStyle['failure-rate-chart']}`} style={{ "--progress-value" : `${summaryReports?.QualityAnalysis?.averageInternalFailureRate}`}} progressval={summaryReports?.QualityAnalysis?.averageInternalFailureRate} role="progressbar" aria-label="Average Internal Failure Rate" aria-valuenow={summaryReports?.QualityAnalysis?.averageInternalFailureRate}>
                </div>
                <span aria-hidden="true"><strong>Average Internal Failure Rate</strong></span>
              </div>
            </div>
            <div className={`ui grid ${QmModuleStyle.ui} ${QmModuleStyle.grid} ${QmModuleStyle['quality-analysis-content']} ${QmModuleStyle.bordered}`}>
              <div className={`column ${QmModuleStyle.column} ${QmModuleStyle['content-block']}`}>
                <h3>External Failure Rate</h3>
                <p>{summaryReports?.QualityAnalysis?.averageExternalFailureRateVerdict}</p>
              </div>
              <div className={`column ${QmModuleStyle.column} ${QmModuleStyle['failure-rate-block']}`}>
                <div className={`${QmModuleStyle['failure-rate-chart']}`} style={{ "--progress-value" : `${summaryReports?.QualityAnalysis?.averageExternalFailureRate}`}} progressval={summaryReports?.QualityAnalysis?.averageExternalFailureRate} role="progressbar" aria-label="Average External Failure Rate" aria-valuenow={summaryReports?.QualityAnalysis?.averageExternalFailureRate}>
                </div>
                <span aria-hidden="true"><strong>Average External Failure Rate</strong></span>
              </div>
            </div>
            <div className={` ui grid ${QmModuleStyle.ui} ${QmModuleStyle.grid} ${QmModuleStyle['quality-analysis-content']}`}>
              <div className={`column ${QmModuleStyle.column} ${QmModuleStyle['content-block']}`}>
                <h3>Average Failure Rate</h3>
                <p>{summaryReports?.QualityAnalysis?.averageFailureRateVerdict}</p>
              </div>
              <div className={`column ${QmModuleStyle.column} ${QmModuleStyle['failure-rate-block']}`}>
                <div className={`${QmModuleStyle['failure-rate-chart']}`} style={{ "--progress-value": `${summaryReports?.QualityAnalysis?.averageFailureRate}` }} progressval={summaryReports?.QualityAnalysis?.averageFailureRate} role="progressbar" aria-label="Average Failure Rate" aria-valuenow={summaryReports?.QualityAnalysis?.averageFailureRate}>
                </div>
                <span aria-hidden="true"><strong>Average Failure Rate</strong></span>
              </div>
            </div>
            <div className={`ui grid ${QmModuleStyle.ui} ${QmModuleStyle.grid} ${QmModuleStyle['quality-analysis-content']}`}>
              <table className={`ui unstackable table ${QmModuleStyle.ui} ${QmModuleStyle.unstackable} ${QmModuleStyle.table}`}>
                <thead>
                  <tr>
                    <th className={`seven wide left aligned  ${QmModuleStyle.wide} ${QmModuleStyle.aligned}`}>Cost Of Quality</th>
                    <th className={`two wide left aligned ${QmModuleStyle.two} ${QmModuleStyle.wide} ${QmModuleStyle.aligned}`}>Cost</th>
                    <th className={`seven wide left aligned  ${QmModuleStyle.wide} ${QmModuleStyle.aligned}`}>Examples</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th colSpan={3} className={`${QmModuleStyle['row-heading']}`}>Cost of Failures</th>
                  </tr>
                  <tr>
                    <th>Internal Failure Cost</th>
                    <td>{checkNum(Number(summaryReports?.QualityAnalysis?.totalCostofInternalFailure))}</td>
                    <td>
                      <ul>
                        {
                          summaryReports?.QualityAnalysis?.internalFailureExamples.map((item,index) => (
                            <li key={index}>{item}</li>
                          ))
                        }
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <th>External Failure Cost</th>
                    <td>{checkNum(Number(summaryReports?.QualityAnalysis?.totalCostOfExternalFailures))}</td>
                    <td>
                      <ul>
                        {
                          summaryReports?.QualityAnalysis?.externalFailureExamples.map((item,index) => (
                            <li key={index+"_51"}>{item}</li>
                          ))
                        }
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <th colSpan={3} className={`${QmModuleStyle['row-heading']}`}>Cost of Investments</th>
                  </tr>
                  <tr>
                    <th>Appraisal Investment Cost</th>
                    <td>{checkNum(Number(summaryReports?.QualityAnalysis?.totalCostOfAssesmentInvestment))}</td>
                    <td>
                      <ul>
                      {
                        summaryReports?.QualityAnalysis?.appraisalInvestementExamples.map((item,index) => (
                          <li key={index+"_51"}>{item}</li>
                        ))
                      }
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <th>Preventive Investment Cost</th>
                    <td>{checkNum(Number(summaryReports?.QualityAnalysis?.totalCostOfPreventiveInvestment))}</td>
                    <td>
                      <ul>
                        {
                          summaryReports?.QualityAnalysis?.preventiveInvestementExamples.map((item,index) => (
                            <li key={index+"_51"}>{item}</li>
                          ))
                        }
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className={`${QmModuleStyle['summary-footer']}`}>
          {
            !(attempt != undefined && user_id != undefined) && <div className={`${QmModuleStyle['summary-btn-container']}`}>
              <Button btnName="BACK TO SIMULATION" btnId="backToSimulationBtn" customBtnStyle={summaryBtnStyle} clickEventHandler={navigateToSimulation} />
              {
                summaryReports.nextattempt ? (<Button btnName="START OVER" btnId="startOverBtn" customBtnStyle={summaryBtnStyle} clickEventHandler={startOverSimulation} />) 
                : (<span style={{'display':'flex'}}><img src={info} alt="info" /><em>You do not have any remaining attempts.</em></span>)
              }              
              <Button btnName="DONE" btnId="doneBtn" customBtnStyle={summaryBtnStyle} clickEventHandler={handlePopupExitSim} />
            </div>
          }
        </div>
      </div>
    </motion.div>
  );
};

export default Summary;